module.exports = __webpack_public_path__ + "img/symbol_15.4a68a1d8.png";